import React from 'react';

export const NewAssignment = React.lazy(() => import('./NewAssignment'));
export const EditAssignment = React.lazy(() => import('./EditAssignment'));
export const TemplatesPage = React.lazy(() => import('./Templates/TemplatesPage'));
export const NewTemplate = React.lazy(() => import('./Templates/NewTemplate'));
export const EditTemplate = React.lazy(() => import('./Templates/EditTemplate'));
export const StartEndWork = React.lazy(() => import('./StartEndWork'));
